import styled from "styled-components";

export const StakeUnstake = styled.div`
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 20px;

  button {
    padding: 0.8rem;
    width: 100%;
    font-size: 12px;
    &:first-child {
      margin-right: ${(props) => (props.space ? "1.2rem" : " ")};
    }
  }
`;
